import { render } from "./CategoryNaviItemLink.vue?vue&type=template&id=2ec0dba7&ts=true"
import script from "./CategoryNaviItemLink.vue?vue&type=script&lang=ts"
export * from "./CategoryNaviItemLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__